jQuery(document).ready(function() {
    // Show/Hide access key
    jQuery('#showHideLink').on('click', function() {
        jQuery('#spbc_key').val(jQuery('#spbc_key').attr('key'));
        jQuery('#spbc_key+div').show();
        jQuery(this).fadeOut(300);
    });

    // Set time zone filed value if key is bad
    if ( !+spbcSettings.key_is_ok ) {
        let d = new Date();
        jQuery('#spbc_admin_timezone').val(d.getTimezoneOffset()/60*(-1));
    }

    /**
     * Shuffle authentication unique keys and salts
     */
    function spbcShuffleSalts() {
        let data = {};
        data.security = spbcSettings.ajax_nonce;
        data.action = 'spbc_action_shuffle_salts';

        jQuery.ajax({
            type: 'POST',
            async: false,
            url: spbcSettings.ajaxurl,
            data: data,
            success: function(result) {
                if (result.success) {
                    document.location.reload();
                } else {
                    alert(result.data);
                }
            },
        });
    }

    // Event for shuffle authentication unique keys and salts
    // Enabling the salt update button and repeatedly pressing
    let actionShuffleSaltsCountClicks = 0;

    jQuery('#action-shuffle-salts').click(function(e) {
        e.preventDefault();

        if (jQuery(this).hasClass('disabled')) {
            actionShuffleSaltsCountClicks++;
            if (actionShuffleSaltsCountClicks === 3) {
                jQuery(this).removeClass('disabled');
            }
        } else {
            actionShuffleSaltsCountClicks = 0;

            if (confirm('Are you sure?')) {
                spbcShuffleSalts();
            }
        }
    });

    jQuery('button[id*="action-adjust-change-"]').click(function(e) {
        e.preventDefault();

        let data = {};
        data.action = 'spbc_action_adjust_change';
        data.adjust = jQuery(this).data('adjust');

        let params = {};
        params.button = document.getElementById('action-adjust-change-' + data.adjust);

        params.success = function() {
            document.location.reload();
        };

        spbcSendAJAXRequest(data, params);
    });

    jQuery('button[id*="action-adjust-reverse-"]').click(function(e) {
        e.preventDefault();

        let data = {};
        data.action = 'spbc_action_adjust_reverse';
        data.adjust = jQuery(this).data('adjust');

        let params = {};
        params.button = document.getElementById('action-adjust-reverse-' + data.adjust);

        params.success = function() {
            document.location.reload();
        };

        spbcSendAJAXRequest(data, params);
    });
});
